export const SIDENAV_LINKS_TYPES = {
    LINK: 'LINK',
    INPUT_WITH_SUBMIT_BUTTON: 'INPUT_WITH_SUBMIT_BUTTON',
    MODAL: 'MODAL',
    REACT_ROUTER_LINK: 'REACT_ROUTER_LINK'
};